// extracted by mini-css-extract-plugin
export var menu = "search-result-sort-menu-module--menu--9e3b1";
export var menuItem = "search-result-sort-menu-module--menuItem--92030";
export var sortText = "search-result-sort-menu-module--sortText--3aa96";